import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    RadioGroup,
    Stack,
    Radio,
    Text,
    Input,
    Flex,
    Box,
    Image,
    useDisclosure,
    Divider,
} from "@chakra-ui/react";
import { useState } from "react";
import { ResponseModal } from "./responseModals";
import { ConfirmeModal } from "./responseModals/ConfirmeModal";

export const RefoundModal = ({ responseVerify, isDisabled }: { responseVerify: any, isDisabled: boolean } ) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [refundType, setRefundType] = useState("partial");
    const [refundValue, setRefundValue] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [isValid, setIsValid] = useState(false);
    const [openResponseModal, setOpenResponseModal] = useState<boolean>(false)
    const [responseModal, setResponseModal] = useState<boolean>(false)

    const handleRefundChange = (value) => {
        setRefundType(value);
        if (value === "total") {
            setRefundValue(responseVerify?.[0].value?.toFixed(2));
            setIsValid(true);
        } else {
            setRefundValue("");
            setIsValid(false);
        }
    };

    const handleInputChange = (e) => {
        const value = e.replace(",", ".");
        setRefundValue(value);

        const maxValue = responseVerify?.[0]?.value || 0;
        const numericValue = Number(value);

        setIsValid(numericValue > 0 && numericValue <= maxValue);
    };

    const handleBlur = () => {
        const maxValue = responseVerify?.[0]?.value || 0;
        const numericValue = Number(refundValue);

        if (numericValue > maxValue) {
            setRefundValue(maxValue.toFixed(2));
            setIsValid(true);
        }
    };


    return (
        <>
            <Button
                colorScheme="pink"
                onClick={onOpen}
                p="0"
                m="0"
                color={"red.danger"}
                fontSize={"1rem"}
                id="excluir_cobrança"
                variant="ghost"
                h="24px"
                maxW="145px"
                transition="filter .2s"
                cursor="pointer"
                isDisabled={isDisabled}
                _hover={
                    {
                        transition: "filter .2s",
                        filter: "brightness(.8)",
                        textDecoration: "underline",
                        color: "red.danger",
                    }
                }
            >
                Estornar cobrança
            </Button>
            <ConfirmeModal
                amount={refundValue}
                openModal={openModal}
                setOpenModal={setOpenModal}
                setResponseModal={setResponseModal}
                setOpenResponseModal={setOpenResponseModal}
            />
            <ResponseModal
                openResponseModal={openResponseModal}
                setOpenResponseModal={setOpenResponseModal}
                setResponseModal={setResponseModal}
                responseModal={responseModal}

            />

            <Modal isOpen={isOpen} onClose={onClose} isCentered>
                <ModalOverlay />
                <ModalContent maxW="520px" borderRadius="2px">


                    <ModalHeader display="flex" fontSize="16px" flexDirection="row" gap="10px">

                        <Image src="/images/icons/questionRefound.svg" />
                        Como você deseja realizar esse estorno?</ModalHeader>
                    <Divider />
                    <ModalBody

                    >
                        <RadioGroup onChange={handleRefundChange} value={refundType}>
                            <Stack direction="row" gap="0" mt={3}>
                                <Flex
                                    p="5px 16px"
                                    w="236px"
                                    h="40px"
                                    cursor="pointer"
                                    color={refundType === "partial" ? "#DF295D" : " black"}
                                    border={refundType === "partial" ? "1px solid #DF295D" : "1px solid #BEBEBE"}
                                    onClick={() => {
                                        setRefundType("partial")
                                        setRefundValue("")
                                        setIsValid(false)

                                    }}
                                >
                                    <Radio
                                        colorScheme={"pink"}
                                        value="partial"

                                    >Parcial</Radio>
                                </Flex>
                                <Flex
                                    ml="0"
                                    w="236px"
                                    h="40px"
                                    p="5px 16px"
                                    cursor="pointer"
                                    color={refundType === "total" ? "#DF295D" : " black"}
                                    onClick={() => {
                                        setRefundType("total")
                                        // setRefundValue(maxAmount)
                                        setRefundValue(responseVerify?.[0]?.value?.toFixed(2))
                                        setIsValid(true)
                                    }}
                                    border={refundType === "total" ? "1px solid #DF295D" : "1px solid #BEBEBE"}

                                >
                                    <Radio
                                        colorScheme={"pink"}
                                        value="total">Total</Radio>
                                </Flex>

                            </Stack>
                        </RadioGroup>

                        <Text m="25px 0" >Digite o valor do estorno que deseja realizar.</Text>

                        {refundType === "partial" ?
                            <Flex
                                flexDirection="column"
                            >


                                <Flex

                                    position="absolute"
                                    alignContent="center"
                                    alignItems="center"
                                    mt="32px"
                                    ml="10px"
                                    color={"gray.600"}
                                >

                                    <Text>
                                        R$
                                    </Text>
                                </Flex>
                                <Flex
                                    flexDirection="column"

                                >
                                    <Text>
                                        Valor do estorno
                                    </Text>

                                    <Input
                                        placeholder="0,00"
                                        pl="35px"
                                        w="240px"
                                        value={refundValue}
                                        onBlur={handleBlur}
                                        onChange={(e) => handleInputChange(e.target.value)}
                                    />
                                    <Text fontSize="sm" color="gray.500" mt={1}>
                                        Valor disponível para estorno R$ {responseVerify?.[0]?.value?.toFixed(2)}
                                    </Text>
                                </Flex>
                            </Flex>
                            :
                            <Text>
                                Será estornado o valor de R$ {responseVerify?.[0]?.value} correspondente a todo o valor disponível para estorno.
                            </Text>

                        }
                    </ModalBody>
                    <Divider />

                    <ModalFooter p="10px 25px" gap="8px">
                        <Button
                            variant="outline"
                            borderRadius="2px"
                            fontSize="14px"
                            w="93px"
                            h="32px"
                            onClick={onClose}
                        >
                            Cancelar
                        </Button>
                        <Button
                            w="90px"
                            h="32px"
                            borderRadius="2px"
                            fontSize="14px"
                            color="white"
                            backgroundColor="#CB2159"
                            isDisabled={!isValid}
                            onClick={() => {
                                setOpenModal(true)
                                onClose()
                            }}
                        >
                            Continuar
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    );
};

